import { $, $$ } from '@utils';

import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-lubes-recent-card]')) return;

  optionHanldeLikeState();
}

function optionHanldeLikeState() {
  $$('[data-au-lubes-recent-card-like]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const button = e.currentTarget;
      const spanInButton = button.querySelector('[data-au-icon]');

      // Toggle the filled class for the like icon
      spanInButton.classList.toggle('au-lubes-recent-card__like-icon--filled');

      const titleText = button
        .closest('[data-au-lubes-recent-card]')
        .querySelector('[data-au-lubes-recent-card-title]').innerText;
      const clickText = button.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(clickText)}_${removeAccentMarkAndUppercase(titleText)}`;

      // datalayer
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickIcono',
        item_id,
      });
    });
  });
}

export default { init };
